import { ShiftResponseDto } from '@operations/app/api'
// import { IShiftFormData } from '@operations/features/operationalEquipment/models/operational-equipment-assignment.model'
import { ShiftUpsertedPayload } from '@operations/app/api/signalRDtos/shiftUpsertedPayload'
import { IShiftFormData } from '@operations/features/shift/models/shift.model'
import { EventTypes } from '@operations/messages/eventsTypes'
import shiftService from '@operations/services/shiftService'
import { IEvent, IMessageBus } from '@tom-ui/utils'
import { Dayjs } from 'dayjs'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'
import { BaseEntityStore } from './base/BaseEntityStore'

export class ShiftStore extends BaseEntityStore<ShiftResponseDto> {
  fetchedAll = false
  selectedShift: ShiftResponseDto | undefined

  constructor(private readonly messageBus: IMessageBus) {
    super()

    makeObservable(this, {
      fetchedAll: observable,
      selectedShift: observable,

      setSelectedShift: action,

      shiftNames: computed,
    })

    this.messageBus.subscribeEvent<ShiftUpsertedPayload>(
      EventTypes.ShiftUpserted,
      this.handleShiftUpsertedEvent,
    )

    this.messageBus.subscribeEvent<number[]>(EventTypes.ShiftDeleted, this.handleShiftDeletedEvent)
  }

  public setSelectedShift(shift: ShiftResponseDto | undefined) {
    this.selectedShift = shift
  }

  public get shiftNames(): string[] {
    return this.items.filter(i => i !== this.selectedShift).map(shift => shift.name)
  }

  public async fetchData() {
    if (this.fetchedAll) return

    const shifts = await shiftService.load()

    this.updateStoreItems(shifts)

    runInAction(() => {
      this.fetchedAll = true
    })
  }

  private dayjsToCreateShiftCommandFrom = (value: Dayjs): string => {
    const h = value.hour().toString().padStart(2, '0')
    const m = value.minute().toString().padStart(2, '0')
    const s = value.second().toString().padStart(2, '0')
    return `${h}:${m}:${s}`
  }

  public async updateShift(formData: IShiftFormData) {
    await shiftService.update({
      ...formData,
      weekDays: formData.weekDays.join(','),
      from: this.dayjsToCreateShiftCommandFrom(formData.from),
      to: this.dayjsToCreateShiftCommandFrom(formData.to),
    } as any)
  }

  public async createShift(formData: IShiftFormData) {
    await shiftService.create({
      ...formData,
      weekDays: formData.weekDays.join(','),
      from: this.dayjsToCreateShiftCommandFrom(formData.from),
      to: this.dayjsToCreateShiftCommandFrom(formData.to),
    } as any)
  }

  public async deleteShifts(ids: number[]) {
    if (!ids || ids.length === 0) return

    await shiftService.delete(ids)
  }

  private readonly handleShiftUpsertedEvent = (res: IEvent<ShiftUpsertedPayload>) => {
    if (!res.payload) return
    this.updateStoreItem(res.payload, res.payload.id)
  }

  private readonly handleShiftDeletedEvent = (res: IEvent<number[]>) => {
    if (!res.payload) return
    this.deleteStoreItems(res.payload)
  }
}
